import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Card, Button, Grid, Dropdown, Input, Icon} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {DEALER_OPTIONS_LIST} from '../static/constansDealerOptions';
import {pageSizes} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import SearchSkrResults from './Results';
import './searchSkr.scss';

class SearchSkr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showFiltersSection': true,
      'limitQuery': 20,
      'dealerFilter': '',
      'formNumberFilter': '',
      'modelFilter': '',
      'titleFilter': '',
      'startDateFilter': '',
      'endDateFilter': '',
    };
    this.changeStartDate = this.changeStartDate.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.onNewClick = this.onNewClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.FormsSkrSearch, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeSearchFtrListPageSize(pageSizes[1].value);
    this.onSearchData(20);
  }

  onSearchClick(limitQuery = null) {
    this.setState({'showFiltersSection': false}, () =>
      this.onSearchData(limitQuery)
    );
  }

  onSearchData(limitQuery) {
    this.props.changeSearchFtrListPage(0);
    const filters = this.getFilters(limitQuery);
    this.props.fetchPublishedAnswersList(filters);
  }

  getFilters(limitQuery) {
    const {dealerFilter, formNumberFilter, modelFilter, titleFilter,
      startDateFilter, endDateFilter} = this.state;
    const filters = {
      'formType': 'SKR',
      'limit': limitQuery,
      'formNumber': formNumberFilter,
      'model': modelFilter,
      'title': titleFilter,
      'startDate': startDateFilter,
      'endDate': endDateFilter,
    };

    if (dealerFilter && dealerFilter !== 'ALL') {
      filters.dealerId = dealerFilter;
    }

    Object.keys(filters).forEach((key) => {
      if (!filters[key]) {
        delete filters[key];
      }
    });

    return filters;
  }

  onCancelClick() {
    this.setState({
      'dealerFilter': '',
      'formNumberFilter': '',
      'modelFilter': '',
      'titleFilter': '',
      'startDateFilter': '',
      'endDateFilter': '',
    }, () => this.onSearchClick(20));
  }

  disableCancelButton() {
    const {loading} = this.props;
    const {dealerFilter, formNumberFilter, modelFilter, titleFilter, startDateFilter} = this.state;
    const emptyAllFilters = !dealerFilter && !formNumberFilter && !modelFilter &&
      !titleFilter && !startDateFilter;

    return loading || emptyAllFilters;
  }

  disableSearchButton() {
    const {loading} = this.props;
    const {dealerFilter, formNumberFilter, modelFilter, titleFilter, startDateFilter} = this.state;
    const requiredFilters = dealerFilter || formNumberFilter || modelFilter ||
      titleFilter || startDateFilter;

    return loading || !requiredFilters;
  }

  updateSearchFilters(value, filterName) {
    this.setState({[filterName]: value});
  }

  updateTextFilters(filterName, value) {
    const finalvalue = value.toUpperCase();
    this.updateSearchFilters(finalvalue, filterName);
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted !== startDateFilter) {
      this.updateSearchFilters(dateFormatted, 'startDateFilter');
    }

    if (!endDateFilter || (endDateFilter && moment(date) > moment(endDateFilter))) {
      this.updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted !== this.state.endDateFilter) {
      this.updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  onNewClick() {
    this.props.navigateTo('/formulario-skr/nuevo');
  }

  onShowFiltersSectionClick(show) {
    this.setState({'showFiltersSection': show});
  }

  renderShowOrHideFilter() {
    const {showFiltersSection} = this.state;
    if (!showFiltersSection) {
      return (
        <Icon
          name='angle right'
          onClick={() => this.onShowFiltersSectionClick(true)}
        />
      );
    }
    return (
      <Icon
        name='angle down'
        onClick={() => this.onShowFiltersSectionClick(false)}
      />
    );
  }

  renderFiltersSection() {
    const {showFiltersSection, dealerFilter, formNumberFilter, modelFilter,
      titleFilter, startDateFilter, endDateFilter} = this.state;

    if (!showFiltersSection) {
      return null;
    }
    return (
      <div className='filters-section'>
        <Grid columns='equal' textAlign='left'>
          <Grid.Row>
            <Grid.Column>
              <Dropdown
                selection
                options={DEALER_OPTIONS_LIST}
                search
                value={dealerFilter}
                onChange={(e, {value}) =>
                  this.updateSearchFilters(value, 'dealerFilter')
                }
                placeholder='Concesionario'
              />
            </Grid.Column>
            <Grid.Column>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={startDateFilter ?
                  moment(startDateFilter, noTimeZoneShortISODate).toDate() : null
                }
                onChange={this.changeStartDate}
                locale='es'
                placeholderText='Fecha Inicio'
              />
            </Grid.Column>
            <Grid.Column>
              <DatePicker
                locale='es'
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={endDateFilter ?
                  moment(endDateFilter, noTimeZoneShortISODate).toDate() : null
                }
                onChange={this.changeEndDate}
                disabled={!startDateFilter}
                minDate={moment(startDateFilter).toDate()}
                placeholderText='Fecha Fin'
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='number'
                placeholder='Número de Form'
                value={formNumberFilter}
                onChange={(e, {value}) => this.updateTextFilters('formNumberFilter', value)}
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='text'
                placeholder='Modelo del vehículo'
                value={modelFilter}
                onChange={(e, {value}) => this.updateTextFilters('modelFilter', value)}
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='text'
                placeholder='Tema'
                value={titleFilter}
                onChange={(e, {value}) => this.updateTextFilters('titleFilter', value)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  render() {
    const {loading} = this.props;
    return (
      <div className='ftr-search-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta de SKR</h2>
              {this.renderShowOrHideFilter()}
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={this.disableCancelButton()}
                  onClick={this.onCancelClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={this.disableSearchButton()}
                  onClick={() => this.onSearchClick(null)}
                >
                  Buscar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={loading}
                  onClick={this.onNewClick}
                >
                  Nuevo
                </Button>
              </div>
            </div>
            {this.renderFiltersSection()}
          </div>
        </Card>
        <SearchSkrResults />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.searchFTR.loading,
    'dealerId': state.session.dealerId,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchPublishedAnswersList,
  changeSearchFtrListPage,
  changeSearchFtrListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchPublishedAnswersList,
  changeSearchFtrListPage,
  changeSearchFtrListPageSize,
})(SearchSkr);
